import type { FieldValues, FieldPath } from "react-hook-form";
import { FormField } from "./FormField";
import {
  CardGroupInput,
  type CardOption,
} from "../ui/CardGroupInput";

interface CardGroupFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> {
  name: TName;
  label?: string;
  options: readonly CardOption[];
  onAfterChange?: (value: string) => void;
  testIdPrefix?: string;
}

export function CardGroupField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, onAfterChange, testIdPrefix, ...inputProps }: CardGroupFieldProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ value, onChange, disabled }) => (
        <CardGroupInput
          {...inputProps}
          testIdPrefix={testIdPrefix}
          value={value}
          onChange={(newValue) => {
            onChange(newValue);
            onAfterChange?.(newValue);
          }}
          disabled={disabled}
        />
      )}
    />
  );
}
